import { GetDetailedInformationAboutDashboardResponseBody } from '../../types/generated/dashboard_get.response';
import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';

export const requestDashboard = (
  id: string,
  token: string | null,
  forceHeader?: string
): Promise<GetDetailedInformationAboutDashboardResponseBody> =>
  fetcher<GetDetailedInformationAboutDashboardResponseBody>(
    `${apiEndpoints.routes.dashboard}/${id}`,
    'GET',
    token,
    forceHeader
  );
